import { useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { pishroKycOtp } from "../../../redux/login/pishroKycOtp";

import { CircularProgress, TextField } from "@mui/material";
import { makeStyles } from "@mui/styles";
import axios from "axios";
import { getUrl } from "common/components/apiConfig";
import { MdOutlineRefresh } from "react-icons/md";
import { useHistory } from "react-router-dom";
import { convertDigitToEnglish } from "../../../common/method/convertDigitToEnglish";
import { pishroOtpLogin } from "../../../redux/login/pishroOtpLogin";
import { actionTypes as actionTypesNotif } from "../../../redux/notificationAlert";
import auth from "../login/login/auth";
import Otp from "./otp";
import Timer from "./timer";

const useStyles = makeStyles((theme) => ({
  greenLinked: {
    color: "black",
    textDecoration: "bottom",
    paddingBottom: 3,
    textAlign: "center",
    "&:hover": {
      color: theme.palette.primary.main,
      fontWeight: 900,
    },
  },
}));

function ConfirmOtp({ setflagLogin, setotpFlag, userInfo }) {
  const { login } = auth();
  const classes = useStyles();
  const history = useHistory();
  const [apiResponse, setApiResponse] = useState(null);
  const [shouldFetchData, setShouldFetchData] = useState(true);
  const [loading, setLoading] = useState(false);
  const [captchaValue, setCaptchValue] = useState("");
  const [InputSmsCode, setInputSmsCode] = useState({
    0: "",
    1: "",
    2: "",
    3: "",
    4: "",
  });

  const dispatch = useDispatch();
  const submiting = async () => {
    let confirmation_token = convertDigitToEnglish(
      `${InputSmsCode[0]}${InputSmsCode[1]}${InputSmsCode[2]}${InputSmsCode[3]}${InputSmsCode[4]}`,
    );
    setLoading(true);

    // let setCookieStorageLogin = async (obj) => {
    //   try {
    //     const objString = obj && JSON.stringify(obj);

    //     const encodedName = encodeURIComponent("admin");
    //     const encodedValue = encodeURIComponent(objString);

    //     let cookieString = encodedName + "=" + encodedValue;

    //     cookieString += "; max-age=" + 30 * 24 * 60 * 60;
    //     cookieString += "; path=/";
    //     cookieString += "; secure";
    //     cookieString += "; SameSite=Lax";

    //     document.cookie = cookieString;
    //   } catch (error) {
    //     console.error("Error setting cookie:", error);
    //   }
    // };
    /**
   @todo: The backend is  to remove the permitted methods from the response.
    **/
    let setCookieStorageLogin = async (obj) => {
      try {
        if (obj && obj.user?.member_permitted_methods) {
          delete obj?.user?.member_permitted_methods;
        }
        const is_expired = obj?.user?.is_expired;
        const objString = obj && JSON.stringify(obj);
        const objString1 = is_expired && JSON.stringify(is_expired);

        const encodedName = encodeURIComponent("admin");
        const encodedValue = encodeURIComponent(objString);
        const isDev = process.env.REACT_APP_IS_DEV === "false";
        let cookieString = encodedName + "=" + encodedValue;
        let cookieString1 = encodeURIComponent("is_expired") + "=" + objString1;

        cookieString += "; max-age=" + (1 * 24 * 60 * 60) / 24;
        cookieString += "; path=/";
        if (!isDev) {
          cookieString += "; Secure";
        }
        cookieString += "; SameSite=Lax";

        document.cookie = cookieString;
        document.cookie = cookieString1;
      } catch (error) {
        console.error("Error setting cookie:", error);
      }
    };

    try {
      const res = await pishroOtpLogin(
        confirmation_token,
        userInfo.nationalId,
        userInfo.isIndividual,
        convertDigitToEnglish(captchaValue),
        apiResponse?.response?.data?._id,
      );

      if (!Object.keys(res.data.response.data).length) {
        return dispatch({
          type: actionTypesNotif.warning,
          textAlert: "کد تایید درست نمی‌باشد. لطفا دوباره تلاش کنید",
        });
      }

      if (res?.data?.response?.is_successful === true) {
        let obj = {
          authToken: res.data.response.data.token,
          authMemberId: res.data.response.data.member_id,
          user: res.data.response.data,
          authenticated: true,
          startTime: new Date(),
        };

        await setCookieStorageLogin(obj);
        const urlParams = new URLSearchParams(window.location.search);
        const page = urlParams.get("page");

        const redirectUrl = page ? decodeURIComponent(page) : "/home";

        login(() => history.push(redirectUrl));
      }
    } catch (error) {
    } finally {
      setLoading(false);
      setShouldFetchData(true);
    }
  };

  const handleClickAgainOtp = () => {
    setLoading(true);
    setShouldFetchData(true);
    pishroKycOtp(userInfo.nationalId, userInfo.isIndividual)
      .then((res) => {
        if (!Object.keys(res.data.response.data).length) {
        }
        if (res?.data?.response?.is_successful === true) {
        }
      })
      .catch(() => {})
      .finally(() => {
        setLoading(false);
      });
  };

  const handleClickExit = () => {
    setflagLogin(0);
    setotpFlag(false);
  };

  const fetchData = async () => {
    try {
      const response = await apiCall();
      setApiResponse(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    if (shouldFetchData) {
      fetchData();
      setShouldFetchData(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldFetchData]);

  const apiCall = () => {
    let config = {
      baseURL: getUrl(),
      method: "POST",
      headers: {
        "content-type": "application/json",
        "Access-Control-Allow-Origin": "*",
      },
      url: "login",
      data: {
        api_key: "d025488f-8ec6-4434-afbe-b6a5343815a7",
        token: null,
        member_id: null,
        table: "clubmember",
        method_type: "get_captcha",
        data: {},
      },
    };

    return axios(config);
  };

  const base64Image = apiResponse?.response?.data?.img;
  const imgSrc = base64Image?.startsWith("data:image")
    ? base64Image
    : `data:image/jpeg;base64,${base64Image}`;
  const handleRefreshClick = () => {
    setShouldFetchData(true);
  };

  const isInputSmsCodeComplete = useMemo(() => {
    return Object.values(InputSmsCode).every((code) => code.length > 0);
  }, [InputSmsCode]);

  useEffect(() => {
    if (
      isInputSmsCodeComplete &&
      captchaValue !== "" &&
      captchaValue.length >= 4
    ) {
      submiting();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isInputSmsCodeComplete, captchaValue]);
  return (
    <>
      <div className="py-4">
        <p className="py-1 m-0">
          کد تایید ارسالی به شماره موبایل سجام خود را وارد کنید.
        </p>
        <div className="form fv-plugins-bootstrap fv-plugins-framework pb-2">
          <Otp
            InputSmsCode={InputSmsCode}
            setInputSmsCode={setInputSmsCode}
            numberOtp={5}
            submiting={submiting}
          />
          <div className="fv-plugins-icon-container mt-1 w-120 ">
            <div className="flex items-center w-100">
              <TextField
                autoFocus={true}
                required
                size="small"
                type="tel"
                placeholder="کد امنیتی"
                inputMode="numeric"
                pattern="[0-9]*"
                className={`w-full border h-12 py-4 px-5 focus:border-gray-400 outline-none rounded-md  authInput mr-3`}
                name="captcha"
                value={captchaValue}
                inputProps={{
                  maxLength: 4,
                  style: {
                    textAlign: "right",
                    direction: "rtl",
                  },
                }}
                onChange={(event) => {
                  setCaptchValue(event.target.value);
                }}
                InputProps={{
                  endAdornment: (
                    <>
                      {apiResponse?.response?.data?.img ? (
                        <img
                          style={{ maxHeight: 36 }}
                          height={16}
                          alt=""
                          src={imgSrc}
                        />
                      ) : (
                        <div
                          style={{
                            minWidth: 70,
                            justifyContent: "center",
                            alignItems: "center",
                            display: "flex",
                          }}
                        >
                          <CircularProgress size={16} />
                        </div>
                      )}
                      <MdOutlineRefresh
                        onClick={handleRefreshClick}
                        style={{ cursor: "pointer", marginInlineStart: 4 }}
                        size={44}
                      />
                    </>
                  ),
                }}
              />
            </div>
            <div className={`errorPlace`}>
              {/* {formik.touched.captcha && formik.errors.captcha ? (
								<div className="fv-plugins-message-container flex mt-1">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="15"
										height="15"
										fill="red"
										className="bi bi-exclamation-triangle-fill"
										viewBox="0 0 16 16">
										<path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
									</svg>
									<div className="fv-help-block d-inline-block mr-1 text-xs text-red-400">
										{formik.errors.captcha}
									</div>
								</div>
							) : null} */}
            </div>
          </div>
          <Timer
            initialMinute={2}
            initialSeconds={0}
            handleClickAgain={handleClickAgainOtp}
          />

          <button
            disabled={!captchaValue}
            onClick={submiting}
            className={`w-full ${
              !captchaValue ? "bg-gray-300" : "bg-primary"
            } text-white rounded-lg h-10 mt-0 text-sm`}
          >
            {loading ? (
              <CircularProgress color="secondary" size={30} />
            ) : (
              <span>تایید و ورود</span>
            )}
          </button>
        </div>
        <div
          role={"button"}
          onClick={() => handleClickExit()}
          to="/login"
          className={`${classes.greenLinked}`}
        >
          بازگشت
        </div>
      </div>
    </>
  );
}
export default ConfirmOtp;
